'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import * as CustomRenderer from '../utils/propTypes/customRenderer';
import UIDialogBody from './UIDialogBody';

function UIWizardStep(_ref) {
  let rest = _objectWithoutPropertiesLoose(_ref, ["backButton", "backLabel", "cancelButton", "cancelLabel", "doneButton", "doneLabel", "hidePrimaryControls", "hideSecondaryControls", "isFirstStep", "isLastStep", "nextButton", "nextLabel"]);

  return /*#__PURE__*/_jsx(UIDialogBody, Object.assign({}, rest));
}

UIWizardStep.propTypes = {
  backButton: CustomRenderer.propType,
  backLabel: PropTypes.node,
  cancelButton: CustomRenderer.propType,
  cancelLabel: PropTypes.node,
  doneButton: CustomRenderer.propType,
  doneLabel: PropTypes.node,
  hidePrimaryControls: PropTypes.bool,
  hideSecondaryControls: PropTypes.bool,

  /** I18n.text string rendered by UIWizardHeaderWithOverview */
  name: PropTypes.string,
  children: PropTypes.node,
  isFirstStep: PropTypes.bool,
  isLastStep: PropTypes.bool,
  nextButton: CustomRenderer.propType,
  nextLabel: PropTypes.node
};
UIWizardStep.displayName = 'UIWizardStep';
export default UIWizardStep;